import type { CorridorIncident, CorridorRoute, VesselTrack } from '@/types/corridor';
import { CORRIDOR_INCIDENTS } from '@/data/corridorIncidents';
import { CORRIDOR_ROUTES, MV_UNITED_S_TRACK } from '@/data/corridorRoutes';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '';
const FETCH_TIMEOUT_MS = 3000;

function fetchWithTimeout(url: string, timeoutMs: number): Promise<Response> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(url, { signal: controller.signal }).finally(() => clearTimeout(timer));
}

export async function fetchCorridorIncidents(): Promise<CorridorIncident[]> {
  if (!API_BASE) return CORRIDOR_INCIDENTS;
  try {
    const res = await fetchWithTimeout(`${API_BASE}/api/corridor/incidents`, FETCH_TIMEOUT_MS);
    if (res.ok) {
      const data = await res.json();
      if (Array.isArray(data.incidents)) return data.incidents;
    }
  } catch {
    // API unavailable, fall through to local data
  }
  return CORRIDOR_INCIDENTS;
}

export async function fetchCorridorRoutes(): Promise<CorridorRoute[]> {
  if (!API_BASE) return CORRIDOR_ROUTES;
  try {
    const res = await fetchWithTimeout(`${API_BASE}/api/corridor/routes`, FETCH_TIMEOUT_MS);
    if (res.ok) {
      const data = await res.json();
      if (Array.isArray(data.routes)) return data.routes;
    }
  } catch {
    // API unavailable, fall through
  }
  return CORRIDOR_ROUTES;
}

export function getVesselTrack(): VesselTrack {
  return MV_UNITED_S_TRACK;
}
